/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Show_LabelInputs */



/**
* | output |
* | --- |
* | "Show label prefix" |
*
* @param {Transcript_Export_Show_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_show_label = /** @type {((inputs?: Transcript_Export_Show_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Show_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show label prefix")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show label prefix")
	return /** @type {LocalizedString} */ ("Show label prefix")
});